import React from 'react';
import * as DatePickerTypeListUI from './DatePickerTypeListUI';
import { DatePickerType } from '../types';
import DatePickerTypeListItem from './DatePickerTypeListItem';

interface IProps {
  value: DatePickerType;
  onChange: (newDatePickerType: DatePickerType) => void;
}

const DatePickerTypeList = ({ value, onChange }: IProps) => {
  const visibleItems: DatePickerType[] = [
    'DatePickerFixed',
    'DatePickerLast',
    'DatePickerLastFull',
    'DatePickerSince',
    'DatePickerStartOf',
  ];

  return (
    <DatePickerTypeListUI.ListContainer>
      {visibleItems.map((curType) => (
        <DatePickerTypeListItem
          key={`date-picker-item-${curType}`}
          selectedDatePickerType={value}
          datePickerType={curType}
          onChange={onChange}
        />
      ))}
    </DatePickerTypeListUI.ListContainer>
  );
};

export default DatePickerTypeList;
